import type { IconSvgObject } from './types';

const Navigation03Icon: IconSvgObject = [
  ["path", { d: "M18.8533 3.91031L4.59603 7.98382C3.65951 8.2514 3.61922 9.56368 4.53756 9.88821L11.1613 12.2289C11.4461 12.3296 11.6702 12.5536 11.7709 12.8384L14.113 19.4627C14.4376 20.381 15.7498 20.3405 16.0173 19.404L20.0896 5.14647C20.3051 4.39214 19.6076 3.69479 18.8533 3.91031Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Navigation03Icon;
